export class CardBatch {
  id?: string;
  store_id?: string;
  channel_id?: string;
  card_def_id?: string;
  flg_dpl?: string;
  num_min: number;
  num_max: number;
  storeDescription?: string;
  channelDescription?: string;
  channelCode?: string;
  card_type_pid?: string;  
  /*cluster_id?: number;  */
  cluster_head_id?: number;
  flg_initial_state: string;
}



// WEBPACK FOOTER //
// ./src/app/models/loyalty-card-batch.model.ts